import { render, staticRenderFns } from "./ChainDiagram.vue?vue&type=template&id=6a455d95&scoped=true&"
import script from "./ChainDiagram.vue?vue&type=script&lang=js&"
export * from "./ChainDiagram.vue?vue&type=script&lang=js&"
import style0 from "./ChainDiagram.vue?vue&type=style&index=0&id=6a455d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a455d95",
  null
  
)

export default component.exports